var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 20.5C20.4069 20.5 21.75 19.1569 21.75 17.5V15.2324C22.3478 14.8866 22.75 14.2403 22.75 13.5V11.5C22.75 10.7597 22.3478 10.1134 21.75 9.76757V7.5C21.75 5.84315 20.4069 4.5 18.75 4.5H5.75C4.09315 4.5 2.75 5.84315 2.75 7.5V17.5C2.75 19.1569 4.09315 20.5 5.75 20.5H18.75ZM19.75 7.5V9.5H18.75C17.0931 9.5 15.75 10.8431 15.75 12.5C15.75 14.1569 17.0931 15.5 18.75 15.5H19.75V17.5C19.75 18.0523 19.3023 18.5 18.75 18.5H5.75C5.19772 18.5 4.75 18.0523 4.75 17.5V7.5C4.75 6.94772 5.19772 6.5 5.75 6.5H18.75C19.3023 6.5 19.75 6.94772 19.75 7.5ZM17.75 12.5C17.75 11.9477 18.1977 11.5 18.75 11.5H20.75V13.5H18.75C18.1977 13.5 17.75 13.0523 17.75 12.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.09f1c7d329c01d09d4bc36bc1c85b918.svg";
export { ForwardRef as ReactComponent };